import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const DashboardHomeView = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        style={{
          backgroundImage: `url("/samaLogo.png")`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "",
          position: "relative",
          filter: "grayscale(17%) contrast(80%)",
          WebkitFilter: "grayscale(27%) contrast(80%)",
        }}
        className="w-full h-full absolute top-0 left-0 z-[0] opacity-20"
      />
    </>
  );
};

export default DashboardHomeView;
